import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
// React 18: use createRoot to remove deprecation warning.
import { createRoot } from 'react-dom/client';

import '@asu/unity-bootstrap-theme/dist/css/unity-bootstrap-theme.css';
import App from './App';
// This import has to happen after `import App`
// eslint-disable-next-line import/order
import { store } from 'core/store';
// state
import './index.scss';
import reportWebVitals from './reportWebVitals';

// NOTE: Temporarily removed <React.StrictMode> to avoid double-mount side effects
// that were triggering repeated auth calls and selector warnings. Once selectors
// are audited to be pure/idempotent, StrictMode can be re-enabled.
const rootEl = document.getElementById('root');
const root = createRoot(rootEl);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
);

// Note: this app is using jsconfig.json file to make paths cleaner.
// Configure project to support absolute import statements.
// https://saurabhshah23.medium.com/react-app-with-absolute-paths-using-jsconfig-json-2b07b1cb24d4

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
